export const QUOTE_STEPS = {
  registrationStartPage: 'profile-info',
  accountInfoPage: 'account-info',
  registrationConfirmationPage: 'confirmation',
};
